import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import moment from 'moment';
import { IBookingSummaryJobType, IBookingProductType } from 'src/app/models/Summary';
import { BookingSummaryJobType } from 'src/globals';

export interface ICustomFilter {
    airportCode: string;
    airlineCode: string;
    productType: IBookingProductType;
    selectedJobType: IBookingSummaryJobType;
    startDate: Date;
    endDate: Date;
}

interface BookingSummaryState {
    bookingSummary: any;
    hasfilterApplied: boolean;
    customFilter: ICustomFilter;
    apiCount: number;
}

const initialState: BookingSummaryState = {
    bookingSummary: [],
    hasfilterApplied: false,
    apiCount: 0,
    customFilter: {
        airportCode: '',
        airlineCode: '',
        productType: 'ABC',
        selectedJobType: BookingSummaryJobType[0] as IBookingSummaryJobType,
        startDate: moment().toDate(),
        endDate: moment().add(6, 'days').toDate(),
    },
};

export const bookingSummarySlice = createSlice({
    name: 'bookingSummary',
    initialState,
    reducers: {
        setStartDate: (state, action: PayloadAction<Date | null>) => {
            state.customFilter.startDate = action.payload;
            state.customFilter.endDate = moment(action.payload).add(6, 'days').toDate();
        },
        setEndDate: (state, action: PayloadAction<Date | null>) => {
            state.customFilter.endDate = action.payload;
        },
        setProduct: (state, action: PayloadAction<IBookingProductType>) => {
            state.customFilter.productType = action.payload;
        },
        setJobType: (state, action: PayloadAction<IBookingSummaryJobType>) => {
            state.customFilter.selectedJobType = action.payload;
        },
        setAirportCode: (state, action: PayloadAction<string>) => {
            state.customFilter.airportCode = action.payload;
        },
        setAirlineCode: (state, action: PayloadAction<string>) => {
            state.customFilter.airlineCode = action.payload;
        },
        applyFilter: (state) => {
            state.hasfilterApplied = true;
            state.apiCount += 1;
        },
        clearFilter: (state) => {
            state.hasfilterApplied = false;

            state.customFilter.airlineCode = '';
            state.customFilter.airportCode = '';
            state.customFilter.productType = 'ABC';
            state.customFilter.selectedJobType = BookingSummaryJobType[0] as IBookingSummaryJobType;
            state.customFilter.startDate = moment().toDate();
            state.customFilter.endDate = moment().add(6, 'days').toDate();
            state.apiCount = 0;
        },
    },
});

export const {
    setAirportCode,
    setAirlineCode,
    setEndDate,
    setProduct,
    setJobType,
    setStartDate,
    applyFilter,
    clearFilter,
} = bookingSummarySlice.actions;
export default bookingSummarySlice.reducer;
